const CustomToolTip = ({ payload }: { payload?: any }) => {
  return (
    <div className="bg-[#1E1B39] rounded-lg text-center px-2 py-1 text-white min-w-[50px] customTooltip">
      {payload?.[0]?.payload.review}
    </div>
  );
};

export default CustomToolTip;
